
namespace TabAurous.Reports {
 
    @Serenity.Decorators.registerClass()
    export class OrderRegisterGrid extends Serenity.EntityGrid<TabAurous.Purchase.OrderRow, any> {
        protected getColumnsKey() { return 'Purchase.Order'; }
        protected getDialogType() { return TabAurous.Purchase.OrderDialog; }
        protected getIdProperty() { return TabAurous.Purchase.OrderRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Purchase.OrderRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Purchase.OrderRow.localTextPrefix; }
        protected getService() { return TabAurous.Purchase.OrderService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: LineChartPanel;
        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Purchase/Order/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true
                },
                field: 'PartyId',
                title: 'Vendor',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                        }
                    } else
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                },

                cssClass: 'hidden-xs'
            });

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            }); 
          

            return filters;
        }
        onViewProcessData(response: Serenity.ListResponse<TabAurous.Purchase.OrderRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new LineChartPanel(this.chartContainer, { items: response.Entities });
             
            return response;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
                    
            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.ApprovalRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date:this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Purchase Order",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }
    }
}